import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/auth";
import { DEMO_MODE, PRACTICE_NAME } from "../lib/config";
import { Icon } from "../components/Icon";

export function LoginPage() {
  const login = useAuthStore((s) => s.login);
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: { pathname: string } } | undefined)?.from?.pathname || "/sessions";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async () => {
    if (DEMO_MODE) {
      navigate("/sessions", { replace: true });
      return;
    }
    if (!email || !password) {
      setErr("Email and password are required.");
      return;
    }
    setBusy(true);
    setErr(null);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Sign-in failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        display: "grid",
        placeItems: "center",
        minHeight: "calc(100vh - 64px)",
        padding: 24,
      }}
    >
      <div className="lock-overlay__card" style={{ maxWidth: 380 }}>
        <div className="lock-overlay__icon">
          <Icon.Heart width={28} height={28} />
        </div>
        <h1 className="lock-overlay__title">{PRACTICE_NAME}</h1>
        <p className="lock-overlay__body">Financing Copilot — staff sign-in.</p>

        {DEMO_MODE ? (
          <>
            <p className="form__hint" style={{ marginBottom: 16 }}>
              Demo mode is on. Click below to enter the prototype.
            </p>
            <button
              className="btn btn--solid"
              onClick={submit}
              style={{ width: "100%", justifyContent: "center" }}
            >
              Enter (demo)
            </button>
          </>
        ) : (
          <>
            <label className="form__row" style={{ marginBottom: 12 }}>
              <span className="form__label" style={{ textAlign: "left" }}>Email</span>
              <input
                className="form__input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                autoComplete="email"
              />
            </label>
            <label className="form__row" style={{ marginBottom: 16 }}>
              <span className="form__label" style={{ textAlign: "left" }}>Password</span>
              <input
                className="form__input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") submit();
                }}
                autoComplete="current-password"
              />
            </label>
            {err && <p className="form__error" style={{ marginBottom: 12 }}>{err}</p>}
            <button
              className="btn btn--solid"
              onClick={submit}
              disabled={busy || !email || !password}
              style={{ width: "auto", minWidth: 120, justifyContent: "center", display: "inline-flex" }}
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
